<h5>{{model?.status | filterList:statusList}}</h5>

<tabset type="pills">
<tab [heading]="visuals.tabHeaderInvDetails">

<div class="row">
  <div class="col-12 block border">
    <div class="wrapper-progressBar">
      <ul class="progressBar">
        <li
          [style.width.%]="100/fields?.length"
          *ngFor="let step of fields; let index = index;"
          [ngClass]="{'success-step':submitting && !form.at(index).invalid,'error-step':submitting && form.at(index).invalid,'active':index == activedStep}"
          (click)="setActive(index)"
        >
          {{ step?.label }}
        </li>
      </ul>
    </div>
  </div>
</div>
<hr />
@if (form) {
  <form [formGroup]="form">
    <div *ngFor="let step of fields; let index = index;">
      <formly-form
        [hidden]="index !== activedStep"
        [form]="form.at(index)"
        [model]="model"
        [fields]="step.fields"
        [options]="options[index]"
      >
      </formly-form>
      <div></div>
    </div>
  </form>
}
@if (form2) {
  <form [formGroup]="form2" *ngIf="!loadingDocuments">
    <div *ngFor="let step of fields2; let index = index;">
      <formly-form
        [hidden]="fields?.length-1 != activedStep"
        [form]="form2"
        [model]="model2"
        [fields]="step.fields"
        [options]="options[index]"
      >
      </formly-form>
      <div></div>
    </div>
  </form>
}

<div *ngIf="loading || loadingDocuments" class="dataLoader"></div>
<div class="centering" *ngIf="actionsflow?.length && !loading">
  <button
    class="btn btn-secondary btn-shadowed m-5"
    style="margin: 5px;"
    type="button"
    (click)="validAll(true)"
  >
    {{genericVisuals.validAll}}
  </button>
  <button
    class="btn btn-secondary btn-shadowed"
    style="margin: 5px;"
    type="button"
    (click)="validAll(false)"
  >
    {{genericVisuals.invalidAll}}
  </button>
  <button class="btn btn-primary btn-shadowed" style="margin: 5px;" (click)="submitForm('')">
    {{genericVisuals.submit}}
  </button>
  <span *ngFor="let act of actionsflow">
    <button
      class="btn btn-primary btn-shadowed"
      (click)="submitForm(act.stateCode)"
      [style.background-color]="act.stateDisplayColour"
      style="margin: 5px;"
    >
      {{act.stateCode | filterList:statusListAlt}}
    </button>
  </span>
</div>
</tab>

<tab [heading]="visuals.tabHeaderAuditTrail">
    <auditTrail *ngIf="!loading" [userId]="userId" [list]="auditList"></auditTrail>
</tab>
</tabset>